import { render, staticRenderFns } from "./BasicOperatorInfoForm.vue?vue&type=template&id=2515f72e"
import script from "./BasicOperatorInfoForm.vue?vue&type=script&lang=js"
export * from "./BasicOperatorInfoForm.vue?vue&type=script&lang=js"
import style0 from "./BasicOperatorInfoForm.vue?vue&type=style&index=0&id=2515f72e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports